import { envs } from '@ctct/infrastructure-layer';

const prodRestrictedPUIDs = [
  1142266133747, // exprealty_grandparent
  1142178942435, // exprealty
  1142266133749, // exprealty_upgrade
];

const l1TestPUIDs = envs.isL1() ? [1100693003223] : [];
const s1TestPUIDs = envs.isS1() ? [1100714113814] : [];

export const NON_INTERACTIVE_TOP_BAR_PUIDS = [...prodRestrictedPUIDs, ...l1TestPUIDs, ...s1TestPUIDs];
